import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "./api";

const AccountCtx = createContext(null);

export function AccountProvider({ children }) {
  const [accounts, setAccounts] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("tj_active_account") || "");

  const load = async () => {
    try {
      const { data } = await api.get("/accounts");
      setAccounts(data);
      if (!activeId && data.length) {
        setActiveId(data[0].id);
        localStorage.setItem("tj_active_account", data[0].id);
      }
    } catch (e) { /* ignore */ }
  };

  useEffect(() => { load(); }, []);

  const setActive = (id) => {
    setActiveId(id);
    localStorage.setItem("tj_active_account", id);
  };

  const activeAccount = accounts.find(a => a.id === activeId) || null;

  return (
    <AccountCtx.Provider value={{ accounts, activeId, activeAccount, setActive, reload: load }}>
      {children}
    </AccountCtx.Provider>
  );
}

export const useAccounts = () => useContext(AccountCtx);
